// Coach Mode routes more than one module needs. The route guard, the Coach
// Mode shell and the coach onboarding wizard all send a coach who awaits
// admin verification to the same screen, so its path lives here once.

// The awaiting verification screen (Figma 09), inside the Coach Mode shell.
export const COACH_VERIFICATION_PATH = "/coach/verification";
